import { formatMessage, multiline } from "../../utils/helpers/LanguageHelper";
import { StandaloneModalProps } from "../layout/StandaloneModal";

/**
 * Markers, returned by the backend, that identify a failure caused by the impossibility
 * of copying the SharePoint user rights while performing a roll forward (duplicate).
 */
const PERMISSION_COPY_ERROR_MARKERS = ["Cannot copy SharePoint user rights", "Cannot verify SharePoint permissions"];

/**
 * Returns true when the given text (an API error entry or an elaboration message detail/text)
 * refers to a SharePoint user rights copy failure during a roll forward.
 */
export const isPermissionCopyErrorText = (text?: string | null): boolean =>
  !!text && PERMISSION_COPY_ERROR_MARKERS.some((marker) => text.includes(marker));

export const isNotAvailableErrorText = (text?: string | null): boolean => {
  const normalizedText = text?.trim().toUpperCase();
  return normalizedText === "N/A" || normalizedText === "NA";
};

export interface RollForwardPermissionModalActions {
  onContinueWithoutRights: () => void;
  onCancel: () => void;
}

/**
 * Builds the props of the single StandaloneModal shown when the SharePoint user rights
 * cannot be copied. It is reused both at invocation time (synchronous 512 error) and at
 * elaboration-response time (asynchronous FAILED elaboration).
 */
export const buildRollForwardPermissionModal = (actions: RollForwardPermissionModalActions): StandaloneModalProps => ({
  modalTitle: formatMessage("cof.elaboration.duplicate.copyuserrights.permission.title"),
  icon: "/assets/notCompatible.svg",
  message: multiline(formatMessage("cof.elaboration.duplicate.copyuserrights.permission.message")),
  type: "confirm",
  actions: [
    {
      id: "continue_without_permissions",
      title: formatMessage("cof.base.proceed"),
      onClick: actions.onContinueWithoutRights,
      variant: "blue",
    },
    {
      id: "cancel_roll_forward",
      title: formatMessage("cof.base.cancel"),
      onClick: actions.onCancel,
      variant: "blue_outlined",
    },
  ],
});
